<router-outlet name="lightbox"></router-outlet>
<div
  *ngIf="activeStream$ | async as activeStream"
  class="magazine-video-wrapper"
  [class.stream-player-error-wrapper]="activeStream.playerConfig?.showErrorScreen"
  [@fadeInOut]
>
  <mb-stream-player-wrapper
    [activeStream]="activeStream"
    [autoplay]="true"
    [transcript]="activeStream.video?.transcript || null"
    [showBackButton]="true"
    (backButton)="closePlayer()"
    (streamStopped)="streamStopped()"
    (openMedia)="openMediaFromTranscript($event)"
  ></mb-stream-player-wrapper>
  <mb-external-player
    *ngIf="activeStream.playerConfig?.externalPlayer"
    [embedCode]="activeStream.playerConfig?.externalPlayer"
    [title]="activeStream.video?.title"
    (backButton)="closePlayer()"
  ></mb-external-player>
</div>

<ng-container *ngIf="magazine">
  <ng-container *ngIf="magazine.sections?.length">
    <ng-container *ngFor="let section of magazine.sections; let index = index">
      <mb-section
        mbRevealWhenVisible
        [index]="index"
        [data]="section"
        [show]="!section.hideInitially"
        (openMedia)="openMedia($event)"
        [ngClass]="section.lightBg ? 'bg-light' : 'bg-dark'"
      ></mb-section>
    </ng-container>
  </ng-container>
</ng-container>
